"use client";

import { useEffect, useState } from "react";

const STATUS_MESSAGES = [
  "Finding the best spots...",
  "Building your day-by-day plan...",
  "Adding restaurants and hidden gems...",
  "Mapping out your route...",
  "Almost there...",
];

// Rotating status copy + a branded indeterminate progress bar so the wait for
// the first (uncached) itinerary generation feels active. Loops through the
// messages (with a fade) rather than freezing on the last one.
export default function ItineraryLoadingStatus() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % STATUS_MESSAGES.length);
        setVisible(true);
      }, 250);
    }, 2200);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="mt-10 flex flex-col items-center">
      <div className="relative h-1.5 w-48 overflow-hidden rounded-full bg-orange-100">
        <div className="absolute inset-y-0 left-0 w-1/2 rounded-full bg-gradient-to-r from-orange-500 to-amber-400 animate-loading-sweep" />
      </div>
      <p
        className={`mt-4 text-center font-medium text-gray-600 transition-opacity duration-300 ${
          visible ? "opacity-100" : "opacity-0"
        }`}
      >
        {STATUS_MESSAGES[index]}
      </p>
    </div>
  );
}
